import { Prismic } from '@landsbankinn/prismic';
import React from 'react';
import { MailingList } from '../components/mailing-list/MailingList';

interface IProps {
  mailing_list_categories: Prismic.RichText;
  fields: ILists[];
}

interface ILists {
  mailing_list_category: Prismic.RichText;
  mailing_list_title: Prismic.RichText;
  mailing_list_text: Prismic.RichText;
  mailing_list_order: number;
}

export const MailingListContainer = ({
  mailing_list_categories,
  fields,
}: IProps) => {
  const stringedLists = fields?.map((item) => ({
    category: Prismic.text(item.mailing_list_category),
    title: Prismic.text(item.mailing_list_title),
    text: Prismic.text(item.mailing_list_text),
    order: item.mailing_list_order,
  }));
  return (
    <MailingList
      categories={Prismic.text(mailing_list_categories) ?? ''}
      lists={stringedLists as any}
    />
  );
};
